export interface ResponseData<T> {
  type: string
  status: string
  code: number
  time: Date
  body: IPage<T>
}

export interface ResponseDataV2<T> {
  type: string
  status: string
  code: number
  time: Date
  body: T
}

export interface IPage<T> {
  content: T[];
  pageable: IPageable;
  totalPages: number;
  totalElements: number;
  last: boolean;
  first: boolean;
  sort: ISort;
  numberOfElements: number;
  size: number;
  number: number;
  empty: boolean;
}

export interface IPageV2<T> {
  content: T[];
  page: number;
  size: number;
  total: number;
}

export function toPage<T>(page: IPageV2<T>): IPage<T> {
  return {
    content: page.content,
    pageable: {
      sort: {
        sorted: false,
        unsorted: true,
        empty: true
      },
      pageNumber: page.page,
      pageSize: page.size,
      offset: page.page * page.size,
      paged: true,
      unpaged: false
    },
    totalPages: Math.ceil(page.total / page.size),
    totalElements: page.total,
    last: (page.page + 1) * page.size >= page.total,
    first: page.page === 0,
    sort: {
      sorted: false,
      unsorted: true,
      empty: true
    },
    numberOfElements: page.content.length,
    size: page.size,
    number: page.page,
    empty: page.content.length === 0
  };
}

export interface IPageable {
  sort: ISort;
  pageNumber: number;
  pageSize: number;
  offset: number;
  paged: boolean;
  unpaged: boolean;
}

export interface ISort {
  sorted: boolean;
  unsorted: boolean;
  empty: boolean;
}

export let defaultPageV2 = {
  content: [],
  page: 0,
  size: 10,
  total: 0,
}

export let defaultPage = {
  content: [],
  pageable: {
    sort: {
      sorted: false,
      unsorted: false,
      empty: false,
    },
    pageNumber: 0,
    pageSize: 10,
    offset: 0,
    paged: false,
    unpaged: false,
  },
  totalPages: 0,
  totalElements: 0,
  last: false,
  first: true,
  sort: {
    sorted: false,
    unsorted: false,
    empty: false,
  },
  numberOfElements: 0,
  size: 10,
  number: 0,
  empty: true,
}
